export default "__VITE_ASSET__1b3d0a8c__"